import { render, staticRenderFns } from "./Advanced.vue?vue&type=template&id=9452c7f4&scoped=true"
import script from "./Advanced.vue?vue&type=script&lang=js"
export * from "./Advanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9452c7f4",
  null
  
)

export default component.exports